export default __webpack_public_path__ + "static/media/interior-and-architectural-fabrication-1000x1000.6c231611.webp";